import type { ThoughtDimensionAttributes } from "@/generated/fastapi";
import type { ThoughtDimensionAttributesExtended } from "@/shared/types";

export const DIMENSION_ATTRIBUTE_DIM0 = "dim0" as const;
export const DIMENSION_ATTRIBUTE_DIM1 = "dim1" as const;
export const DIMENSION_ATTRIBUTE_DIM2 = "dim2" as const;
export const DIMENSION_ATTRIBUTE_DIM3 = "dim3" as const;

export const DIM_ATTR_CANONOICAL_LIST: readonly ThoughtDimensionAttributes[] =
  Object.freeze([
    DIMENSION_ATTRIBUTE_DIM0,
    DIMENSION_ATTRIBUTE_DIM1,
    DIMENSION_ATTRIBUTE_DIM2,
    DIMENSION_ATTRIBUTE_DIM3,
  ] as ThoughtDimensionAttributes[]);

export const dimensionOptions: Record<
  ThoughtDimensionAttributesExtended,
  string
> = Object.freeze({
  dim0: "Dim1",
  dim1: "Dim2",
  dim2: "Dim3",
  dim3: "Dim4",
  all: "All",
});
